/* globals ServerFormater, XmlElement, DATA_STATE_CLEAN, DATA_STATE_DIRTY */

/* eslint-disable camelcase, new-cap */
function SharedData (SharedDataId, SharedDataValId, Data) {
    this.SharedDataId = SharedDataId;
    this.SharedDataValId = SharedDataValId;
    this.Data = Data;

    this.DataState = DATA_STATE_CLEAN;
}

SharedData.prototype.toString = function () {
    return "SharedDataId="
        + this.SharedDataId
        + ", SharedDataValId="
        + this.SharedDataValId
        + ", Data="
        + this.Data;
};

SharedData.prototype = {
    GetXml: function () {
        var ServerFormat = new ServerFormater(),
            xml = new XmlElement("SD");

        xml.AddAttribute("SDVI", this.SharedDataValId);
        xml.AddAttribute("D", ServerFormat.TrimToLength(this.Data, 64000));

        return xml.toString();
    },

    GetData: function () {
        return this.Data;
    },

    WriteData: function (newData) {
        this.Data = newData;
        this.SetDirtyData();
    },

    SetDirtyData: function () {
        this.DataState = DATA_STATE_DIRTY;
    }
};
